import Vue from 'vue';
import type { INotificationModalResource } from '@rready/sdk';
import type { ModalType } from './modalCaptureMixin';
import { ModalCloseEventName, ModalOpenEventName } from './modalCaptureMixin';

export const modalMixin = Vue.extend({
  methods: {
    $modal(type: ModalType, content: INotificationModalResource) {
      this.$nextTick(() => {
        const event = new CustomEvent(ModalOpenEventName, {
          bubbles: true,
          detail: {
            type,
            content
          }
        });
        this.$el.dispatchEvent(event);
      });
    },
    $modalClose() {
      this.$nextTick(() => {
        const event = new CustomEvent(ModalCloseEventName, {
          bubbles: true
        });
        this.$el.dispatchEvent(event);
      });
    }
  }
});
